import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import Condition from '@/utils/condition';
import clsx from 'clsx';
import '@/components/slider-type/components/congratulation/congratulation-v1.css';
import '@/components/slider-type/components/congratulation/congratulation-v2.css';

export default function Congratulation() {
  const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);
  const congratulations = useAppSelector(ConfigSlice.selectors.signCongratulation);
  const withEmojies = useAppSelector(ConfigSlice.selectors.signWithEmojies);
  const titleSuccessColor = useAppSelector(ConfigSlice.selectors.signTitleSuccessColor);

  const congratulation = Condition.getFirst(congratulations);

  if (!congratulation) return null;

  return (
    <div data-css-version={cssVersion} className='slider-type-congratulation'>
      <p
        className={clsx('slider-type-congratulation__title', {
          'slider-type-congratulation__title--success': titleSuccessColor,
        })}
      >
        {congratulation.title}&nbsp;{cssVersion === 2 && withEmojies ? '🎉' : ''}
      </p>
      <p className='slider-type-congratulation__content'>{congratulation.content}</p>
    </div>
  );
}
